import FavoriteIcon from '@mui/icons-material/Favorite';
import InvertColorsIcon from '@mui/icons-material/InvertColors';
import PsychologyIcon from '@mui/icons-material/Psychology';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import SportsMartialArtsIcon from '@mui/icons-material/SportsMartialArts';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { Chip, Grid, ListItemAvatar, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import React, { ReactNode } from "react";
import { Article } from '../_/components/Article';
import { DamageIcon, DodgeIcon, ShieldIcon, SwordIcon } from "../_/components/icons/Icons";
import { HintSubjects, Ref } from '../_/components/Reference';
import { feats } from "../content/feats";
import { ProgressTable } from './ProgressTable';

export const Character = () => (
    <>
        <Article.Title>Statystyki</Article.Title>
        <Article.Body>
            <StatLine
                name={"Ciało"}
                icon={<SportsMartialArtsIcon fontSize="large" />}
                description="Określa fizyczną siłę i wytrzymałość postaci. Wpływa na obrażenia fizyczne i ilość punktów życia" />
            <StatLine
                name={"Ostrość"}
                icon={<RemoveRedEyeIcon fontSize="large" />}
                description="Określa zwinność, percepcję i refleks. Wpływa na inicjatywę oraz rzuty na atak i uniki"
            />
            <StatLine
                name={"Umysł"}
                icon={<PsychologyIcon fontSize="large" />}
                description="Określa zdolności umysłowe postaci. Zwiększa ilość punktów zdolności"
            />
            <StatLine
                name={"Duch"}
                icon={<SelfImprovementIcon fontSize="large" />}
                description="Określa silną wolę i wpływ na inne postacie. Spowalnia upadek postaci i wpływa na manę"
            />
        </Article.Body>
        <Article.Title>Poziom statystyk </Article.Title>
        <Article.Body>
            Poziom statystyk przyjmuje wartości od 0 do 5, przy czym postacie graczy nie mogą mieć statystyk większych niż 3. Każdemu poziomowi cechy odpowiada kość w następujący sposób:
            <StatsLevelTable />    
        </Article.Body>
        

        <Article.Title>
            Statystyki dodatkowe
        </Article.Title>
        <Article.Body>
            <StatLine
                name={"Obrażenia"}
                icon={<DamageIcon size={"28px"} />}
                description="Obrażenia zadawane przy ataku równe są obrażeniom używanej broni plus poziom Ciała."
            />
            <StatLine
                name={"Atak"}
                icon={<SwordIcon size={"28px"} />}
                description="Kość używana do ataku, równa jest kości Ostrości."
            />
            <StatLine
                name={"Uniki"}
                icon={<DodgeIcon size={"48px"} />}
                description="Kość używana do uników, równa jest kości Ostrości."
            />
            <StatLine
                name={"Pancerz"}
                icon={<ShieldIcon size={"28px"} />}
                description="Pancerz redukuje otrzymywane obrażenia fizyczne o jego wartość. Na pancerz wpływa noszony pancerz i tarcza."
            />
            <StatLine
                name={"Punkty życia"}
                icon={<FavoriteIcon fontSize="inherit" sx={{ fontSize: 28 }} />}
                description="Początkowe punkty życia to 30 + 5 za każdy punkt Ciała" />
            <StatLine
                name={"Mana"}
                icon={<InvertColorsIcon fontSize="inherit" sx={{ fontSize: 28 }} />}
                description="Potrzebna do podtrzymywania magicznych efektów oraz noszenia megicznych artefaktów. Mana równa jest Duszy"
            />
            <StatLine
                name={"Upadek"} // łzy
                icon={<TrendingDownIcon fontSize="inherit" sx={{ fontSize: 28 }} />}
                description="Upadek określa stan psychiczny i determinację postaci na drodze do osiągania jej celów."
            />
        </Article.Body>

        <Article.Title>
            Atuty
        </Article.Title>
        <Article.Body>
            Atuty określają silne strony postaci jej umiejętności lub cechy characteru i służą do <Ref subject={HintSubjects.Focus}>skupiania kości</Ref> cech.
            W niektórych przypadkach posiadanie atutu może być wymagane, żeby w ogóle podjąć próbę testu,
             na przykład uważenie eliksitu, przeprowadzenie operacji czy zhackowanie komputera
            wymagana okreslonych umiejętności i bez ich posiadania test w ogóle nie może zostać wykonany.
            Poniżej przedstawiono listę przykładowych atutów, ale razem z Gapiem możecie dodać takie, które będą pasowały do Waszych postaci.
            {feats.map(feat => <Chip label={feat} variant="outlined" sx={{ margin: "2px" }} />)}
        </Article.Body>

        <Article.Title>
            Rozwój i poziomy
        </Article.Title>
        <Article.Body>
            Postać zaczyna przygodę na 1 poziomie z dwiema statystykami ustawionymi na 1 (pozostałe dwie zostają na 0), 
            następnie może podnieść dowolną statystykę o 1. Dodatkowo postać zaczyna z:
            <ul>
                <li>dwoma Atutami</li>
                <li>jedną Zdolnością</li>
                <li>jednym przedmiotem w plecaku</li>
                <li>kością zasobów K20</li>
                <li>majątkime równym 10unic</li>
                <li>pełnym rynszunkiem o standardowej jakości</li>
                <li>Determinacją równą 10</li>
            </ul>

            O tym kiedy postacie awansują na kolejny poziom decyduje Gap, ale żeby w ogóle mogło do tego dojść postać będzie musiała nauczyć się
            nowego Atutu. Żeby to zrobić musi go wybrać i zaprezentować go w przygodzie, dopiero wtedy może wpisać go na kartę. 

            Na każdym kolejnym poziomie postać podnosi jedną statystykę o 1 oraz zdobywa jedną Zdolność. 
            Postacie graczy mogą awansować na maksymalnie 5 poziom. 

            <br/><br/>Liczba dostępnych rozwinięć na poszczególnych poziomach przedstawia poniższa tabela:
            <ProgressTable />
            { false &&
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell ></TableCell>
                            <TableCell colSpan={3} align="center">Rozwinięcie</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Poziom</TableCell>
                            <TableCell align="center">Cecha</TableCell>
                            <TableCell align="center">Atut</TableCell>
                            <TableCell align="center">Punkty zdolności</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <LevelRow level={0}
                            stat statOverride="1/1/1/0"
                            feat
                        />
                        <LevelRow level={1} feat skill />
                        <LevelRow level={2} feat skill />
                        <LevelRow level={3} stat />
                        <LevelRow level={4} feat skill />
                        <LevelRow level={5} feat skill />
                        <LevelRow level={6} stat />
                        <LevelRow level={7} feat skill />
                        <LevelRow level={8} feat skill />
                        <LevelRow level={9} stat />
                        <LevelRow level={10} specialization />
                    </TableBody>
                </Table>
            </TableContainer>
            }
        </Article.Body>
    </>
)


type Props = {
    name: string,
    icon: ReactNode,
    description: string
}
const StatLine = ({ name, icon, description }: Props) => (
    <ListItem alignItems="flex-start">
        <ListItemAvatar>
            {icon}
            {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" /> */}
        </ListItemAvatar>
        <ListItemText
            primary={name}
            secondary={
                <React.Fragment>
                    {description}
                </React.Fragment>
            }
        />
    </ListItem>
)

const StatsLevelTable = () => {
    const rows = [
        { level: 0, dice: "K20" },
        { level: 1, dice: "K12" },
        { level: 2, dice: "K10" },
        { level: 3, dice: "K8" },
        { level: 4, dice: "K6" },
        { level: 5, dice: "K4" }
    ]
    return (
        <Grid container spacing={2}>
            <Grid item xs={9}>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table" >
                        <TableBody>

                            <TableRow>
                                <TableCell align="right" width="30px">Poziom</TableCell>
                                {rows.slice(0, 4).map(row => <TableCell sx={{ maxWidth: '15px' }}> {row.level} </TableCell>)}
                            </TableRow>
                            <TableRow >
                                <TableCell align="right" width="30px">Kość</TableCell>
                                {rows.slice(0, 4).map(row => <TableCell sx={{ maxWidth: '15px' }} > {row.dice} </TableCell>)}
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item xs={3}>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table" >
                        <TableBody>

                            <TableRow>
                                {rows.slice(-2).map(row => <TableCell sx={{ maxWidth: '15px' }}> {row.level} </TableCell>)}
                            </TableRow>
                            <TableRow >
                                {rows.slice(-2).map(row => <TableCell sx={{ maxWidth: '15px' }}> {row.dice} </TableCell>)}
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

type SkillLineProps = {
    name: string, description: string
}
const SkillLine = ({ name, description }: SkillLineProps) => (
    <ListItem alignItems="flex-start">
        <ListItemText
            primary={name}
            secondary={
                <React.Fragment>
                    {description}
                </React.Fragment>
            }
        />
    </ListItem>
)

type LevelRowProps = {
    level: number,
    stat?: boolean,
    statOverride?: string,
    feat?: boolean,
    featCustomText?: string,
    skill?: boolean,
    specialization?: boolean
}

const LevelRow = ({ level, stat = false, statOverride, feat = false, featCustomText, skill, specialization = false }: LevelRowProps) => {
    const statText = statOverride ? statOverride : "X";
    const featText = featCustomText ? featCustomText : "X";
    return (
        <TableRow>
            {!specialization ? (
                <>
                    <TableCell>{level}</TableCell>
                    <TableCell align="center">{stat ? statText : ""} </TableCell>
                    <TableCell align="center">{feat ? featText : ""}</TableCell>
                    <TableCell align="center">{skill ? "1" : ""}</TableCell>
                </>
            )
                : ( 
                    <>
                        <TableCell>{level}</TableCell>
                        <TableCell colSpan={3} align="center">{"specjalizacja"}</TableCell>
                    </>
                )
            }</TableRow>
    )
}
